"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { usePlausible } from "next-plausible";

export default function PlausiblePageEvent() {
  const pathname = usePathname();
  const plausible = usePlausible();

  useEffect(() => {
    const canonicalMeta = document.querySelector('link[rel="canonical"]');
    const href = canonicalMeta.getAttribute("href");
    const url = canonicalMeta ? href : window.location.href;

    plausible("pageview", { u: url });
  }, [pathname]);

  return null;
}
